import type { AnimationTimingConfig } from './index';

const ANIMATION_TIMINGS: AnimationTimingConfig = {
	fullScreenActions: 700,
	fullscreenInput: 300,
	sidebarActions: 100,
};

export { ANIMATION_TIMINGS };
